import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { faCirclePlus, faIcons } from "@fortawesome/free-solid-svg-icons";
import {
  IAppDashboardMenu,
  IMenuItemPermissions,
  IMenuItem,
  PluginInjectorApplicationPlugin,
  PluginInjectorService,
} from "core-client/api";
import { BehaviorSubject, combineLatest, map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MenuItemControlService {
  private readonly pluginModuleTitle = "MENUITEM";
  private readonly navbarMenuTitleAdd = "MENUITEM_ADD";
  private readonly menuItemPermissions: IMenuItemPermissions = {
    menuitem: { core_plugin_menuitem_dashboard_edit: false },
  };

  //private readonly menuItemAddDisabled: Observable<boolean>;

  constructor(private readonly pluginInjectorService: PluginInjectorService) {
    // Access controlled by WIDGET_LOCK/WIDGET_UNLOCK
    /*this.menuItemAddDisabled = combineLatest([
      this.pluginInjectorService.widgetService.edit$,
    ]).pipe(map(([active]) => !active));*/
  }

  getNavbarMenuItem(
    pluginConfig: PluginInjectorApplicationPlugin.IApplicationPlugin,
    dashboardMenu: IMenuItem[],
    primaryEnabled: boolean,
    secondaryEnabled: boolean,
  ): IMenuItem[] {
    const menuItemsPermissionsRefs = this.getMenuItemPermissionRefs();
    const menuItemAdd: IMenuItem = {
      pluginId: pluginConfig._id,
      pluginName: pluginConfig.name,
      pluginModule: this.pluginModuleTitle,
      nameIdentifier: this.navbarMenuTitleAdd,
      accessRights: menuItemsPermissionsRefs,
      primary: {
        enabled: primaryEnabled,
        position: dashboardMenu.length + 1,
      },
      secondary: {
        enabled: secondaryEnabled,
        position: dashboardMenu.length + 1,
      },
      strictMode: true,
      headerSortOrder: 10,
      iconLayers: [
        { icon: faIcons },
        { icon: faCirclePlus, transform: "shrink-6 right-8 down-8" },
      ],
      dropdown: false,
      disabled: new BehaviorSubject(false), // this.menuItemAddDisabled,
      callback: async (dialog: MatDialog, id?: string) => {
        await this.openMenuDialog(dialog, id);
      },
    };

    if (!this.doesMenuExist(this.navbarMenuTitleAdd, dashboardMenu)) {
      dashboardMenu.push(menuItemAdd);
    }

    return dashboardMenu;
  }

  getMenuItemPermissions(): IMenuItemPermissions {
    return this.menuItemPermissions;
  }

  private getMenuItemPermissionRefs(): string[] {
    let menuItemsPermissionsRefs: string[] = [];
    for (const menuItemFlag in this.menuItemPermissions) {
      menuItemsPermissionsRefs = Object.keys(
        this.menuItemPermissions[menuItemFlag],
      );
    }
    return menuItemsPermissionsRefs;
  }

  private async openMenuDialog(dialog: MatDialog, id?: string): Promise<void> {
    const { MenuItemNavbarMenuItemComponent } = await import(
      "./navbar-menu-item/navbar-menu-item.component"
    );
    const dialogConfig = this.pluginInjectorService.getMenuDialogConfig();
    const dialogRef = dialog.open(MenuItemNavbarMenuItemComponent, {
      ...dialogConfig,
      panelClass: ["adx-plugin-default-dialog-content", "adx-dialog-large"],
      data: { id },
    });
    this.pluginInjectorService.setMenuDialogRef(dialogRef);
  }

  private doesMenuExist(
    nameIdentifier: string,
    dashboardMenu: IAppDashboardMenu[],
  ): boolean {
    return dashboardMenu.some(
      (item: IAppDashboardMenu) =>
        item.nameIdentifier.toLowerCase() === nameIdentifier.toLowerCase(),
    );
  }
}
